import { render, staticRenderFns } from "./GeneralInfoUser.vue?vue&type=template&id=0665d01a"
import script from "./GeneralInfoUser.vue?vue&type=script&lang=js"
export * from "./GeneralInfoUser.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfoUser.vue?vue&type=style&index=0&id=0665d01a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports